import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_BACKEND_BASE_URL;

/**
 * Auth API - unified login via backend endpoint.
 * Supports admin/moderator/subscriber credentials through `POST /auth/login`.
 */
export const authApi = {
  login: async (email, password) => {
    const base = API_BASE_URL || '';
    const response = await axios.post(`${base}/auth/login`, {
      email,
      password,
    }, {
      headers: { 'Content-Type': 'application/json' },
      timeout: 20000,
    });
    return response.data;
  },
};

export default authApi;
